// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
export function updateMessageCodeBlock(contentText, answer, fromCodeIdx, toCodeIdx, newCode) {
    const fromAnswerIdx = contentText.indexOf(answer);
    // const toAnswerIdx = fromAnswerIdx + answer.length;
    const correctedFromCodeIdx = fromCodeIdx + fromAnswerIdx;
    const correctedToCodeIdx = toCodeIdx + fromAnswerIdx;
    const newContentText = contentText.slice(0, correctedFromCodeIdx) +
        newCode +
        contentText.slice(correctedToCodeIdx);
    return newContentText;
}
